import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SelectAllCheckbox from "../../../components/Modal/SelectAllCheckbox";
import axios from "axios";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { toast } from "react-toastify";

function AddUserFormm() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const { id } = useParams();
  const [outlets, setOutlets] = useState([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    password_confirmation: "",
    role: "super_admin",
    designation: "",
    country: "",
    passport_no: "",
    iqama_no: "",
    module_access: "[]",
    outlet_id: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  const handleModuleAccesSelect = useCallback(
    (modules) => {
      setFormData({
        ...formData,
        module_access: JSON.stringify(modules),
      });
    },
    [formData]
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!id) {
      axios
        .post(`${apiKey}/api/rms/admin/register`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      axios
        .put(`${apiKey}/api/rms/admin/update/${id}`, formData, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          toast.success("Success", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          Object.keys(err.response.data.data).forEach((item) => {
            err.response.data.data[item].forEach((i) => {
              toast.error(i || "Validation Error");
            });
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/get-outlets`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setOutlets(res.data);
      })
      .catch((err) => {
        setError(err.response.data.message || "An Error Occured");
      });
  }, [user?.token]);

  useEffect(() => {
    if (id) {
      axios
        .get(`${apiKey}/api/rms/admin/user/${id}`, {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        })
        .then((res) => {
          setFormData(res.data);
        })
        .catch((err) => {
          setError(err.response.data.message);
        });
    }
  }, [id, user?.token]);

  if (error) {
    return <MessageCard error={error} />;
  }
  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-d-bg-text text-2xl"> Add User</h1>
          </div>
        </div>
        <div className="w-full">
          <form action="" className="w-full" onSubmit={handleSubmit}>
            <div className="grid grid-cols-3 gap-x-8 gap-y-2 w-full ">
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Name
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Name"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    onChange={handleChange}
                    value={formData.name}
                    name="name"
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Email Address
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Email"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    onChange={handleChange}
                    value={formData.email}
                    name="email"
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2  font-bold">
                  Phone
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Phone"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    onChange={handleChange}
                    value={formData.phone}
                    name="phone"
                  />
                </div>
              </label>
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Designation
                </span>
                <span className="text-xs pl-2 text-d-bg-text font-bold">
                  Enter Waiter for waiter, to be appeared in waiter dropdown in
                  POS screen
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" Designation"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    onChange={handleChange}
                    value={formData.designation}
                    name="designation"
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 font-bold">
                  Role
                </span>
                <div className="mb-2 pt-0">
                  <select
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    id=""
                    onChange={handleChange}
                    value={formData.role}
                    name="role"
                  >
                    <option value="super_admin">System User</option>
                    <option value="cashier">Cashier</option>
                    <option value="rider">Rider</option>
                    <option value="web_user">Web User</option>
                    <option value="display_user">Display User</option>
                    <option value="accountant">Accountant</option>
                    <option value="product_manager">Product Manager</option>
                  </select>
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 font-bold">
                  Outlet
                </span>
                <div className="mb-2 pt-0">
                  <select
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    id=""
                    onChange={handleChange}
                    value={formData.outlet_id}
                    name="outlet_id"
                  >
                    <option value="">Select</option>
                    {outlets.map((outlet, index) => (
                      <option value={outlet.id} key={index}>
                        {outlet.name}
                      </option>
                    ))}
                  </select>
                </div>
              </label>
              {formData.role === "rider" && (
                <>
                  <label htmlFor="">
                    <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Country
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Email"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required
                        onChange={handleChange}
                        value={formData.country}
                        name="country"
                      />
                    </div>
                  </label>

                  <label htmlFor="">
                    <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Passport Number
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Email"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required
                        onChange={handleChange}
                        value={formData.passport_no}
                        name="passport_no"
                      />
                    </div>
                  </label>

                  <label htmlFor="">
                    <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                      Iqama Number
                    </span>
                    <div className="mb-2 pt-0">
                      <input
                        type="text"
                        placeholder="Email"
                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                        required
                        onChange={handleChange}
                        value={formData.iqama_no}
                        name="iqama_no"
                      />
                    </div>
                  </label>
                </>
              )}

              {/* <label htmlFor=""></label> */}
              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                  Password
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder=" Password"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    onChange={handleChange}
                    value={formData.password}
                    name="password"
                  />
                </div>
              </label>

              <label htmlFor="">
                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2  font-bold">
                  Confirm Password
                </span>
                <div className="mb-2 pt-0">
                  <input
                    type="text"
                    placeholder="Confirm Password"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    required
                    onChange={handleChange}
                    value={formData.password_confirmation}
                    name="password_confirmation"
                  />
                </div>
              </label>

              <label htmlFor=""></label>
            </div>

            <div className="w-full my-5">
              <h1 className="text-sm  text-d-bg-text relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                Menu Access
              </h1>
              <SelectAllCheckbox
                handleModuleAccesSelect={handleModuleAccesSelect}
                role={formData.role}
                module_access={formData.module_access}
              />
            </div>

            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="/assets/gif/button_loader.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default AddUserFormm;
